import { render, staticRenderFns } from "./OoaStatusChip.vue?vue&type=template&id=c534d544&scoped=true&"
import script from "./OoaStatusChip.vue?vue&type=script&lang=js&"
export * from "./OoaStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./OoaStatusChip.vue?vue&type=style&index=0&id=c534d544&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c534d544",
  null
  
)

export default component.exports